// extracted by mini-css-extract-plugin
module.exports = {"mobileSaLogoBox":"SALogo_mobileSaLogoBox__sTIJ2","mobileSaLogoIcon":"SALogo_mobileSaLogoIcon__5BxUb","leftToRight":"SALogo_leftToRight__sx986"};